import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import * as VueGoogleMaps from "vue2-google-maps";
import VueHtmlToPaper from 'vue-html-to-paper';

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBCWyTQMDybKhve6ILFtDLIidhj9Mnulsk", //process.env.VUE_APP_API_KEY_MAPS,
    libraries: "places" // necessary for places input
  }
});

Vue.use(VueHtmlToPaper);

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
